import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function forceScrollTop() {
  if (typeof window === 'undefined') return;
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
}

/**
 * Restaura o scroll ao topo em toda mudança de rota.
 * Admin usa containers internos com scroll próprio e é ignorado.
 * Usa pathname + key e um segundo tick (rAF) para páginas lazy que montam depois.
 */
const ScrollRestoration = () => {
  const { pathname, key, hash } = useLocation();

  useEffect(() => {
    if (pathname === '/admin' || pathname.startsWith('/admin/')) {
      return undefined;
    }

    // Âncoras (#contact-form etc.) cuidam do próprio scroll
    if (hash) {
      return undefined;
    }

    forceScrollTop();
    const raf = requestAnimationFrame(() => {
      forceScrollTop();
    });
    // Conteúdo async (Suspense / fetch) pode crescer após o primeiro paint
    const t = window.setTimeout(forceScrollTop, 0);

    return () => {
      cancelAnimationFrame(raf);
      window.clearTimeout(t);
    };
  }, [pathname, key, hash]);

  return null;
};

export default ScrollRestoration;
